import { useState } from 'react';

const useFilterState = (defaults) => {
    const reset = new Set(defaults.filters);
    const [selectedFilters, setSelectedFilters] = useState(reset);
    const resetState = () => setSelectedFilters(reset);

    const addFilter = (filter) => {
        const newState = new Set(selectedFilters);
        newState.add(filter);
        setSelectedFilters(newState);
    };

    const removeFilter = (filter) => {
        const newState = new Set(selectedFilters);
        newState.delete(filter);
        setSelectedFilters(newState);
    };

    const removeAllFilters = () => {
        const newState = new Set(selectedFilters);
        newState.forEach((f) => newState.delete(f));
        setSelectedFilters(newState);
    };

    const toggleFilter = (filter, limited, handleFilterFunc) => {
        // update fund type filter to display selected filter
        // origin - ScreenerFilters.js, onFundTypeChange()
        if (handleFilterFunc) handleFilterFunc(filter);

        // if the filter selection is limited to one remove current filter
        if (limited && selectedFilters.size >= 1) {
            selectedFilters.forEach((f) => {
                if (f !== filter) selectedFilters.delete(f);
            });
        }

        return selectedFilters.has(filter)
            ? removeFilter(filter)
            : addFilter(filter);
    };

    const api = {
        resetState,
        addFilter,
        removeFilter,
        removeAllFilters,
        toggleFilter,
        defaults
    };
    return { selectedFilters, ...api };
};

export default useFilterState;
